export const colorPalette = {
  light150: '#fafafa',
}
